export const blockIconsContentAdd = (
	<span className='material-symbols-outlined'>add</span>
);
